<template>
  <div class="cp-right">
    <a class="combtn site" target="_blank" href="https://xx2.ztgame.com/index.shtml">前往官网</a>
    <a class="combtn yxreg" target="_blank" href="https://reg.ztgame.com/">游戏注册</a>
    <a class="combtn search_role" target="_blank" href="http://xx2.ztgame.com/act/usr/">查找角色</a>
    <a class="combtn acc_cz" target="_blank" href="https://pay.ztgame.com/">账户充值</a>
    <a class="top" @click="goTop()">top</a>
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
    .cp-right{
      width 195px;
      height 387px;
      background url('./images/right_banner.png') no-repeat;
      position fixed;
      top 512px;
      right 80px;
      z-index 10;
      .combtn{
        width 122px;
        height 38px;
        display block;
        text-indent -9999px;
        margin 0 auto;
        margin-top 10px;
        background url('./images/wlbtn.png') no-repeat 0 0;
        cursor pointer;
      }
      .site{
        margin-top 39px;
        &:hover{
          background url('./images/wlbtn.png') no-repeat -140px 0;
        }
      }
      .yxreg{
        background url('./images/wlbtn.png') no-repeat 0 -48px;
        &:hover{
          background url('./images/wlbtn.png') no-repeat -140px -48px;
        }
      }
      .search_role{
        background url('./images/wlbtn.png') no-repeat 0 -95px;
        &:hover{
          background url('./images/wlbtn.png') no-repeat -140px -95px;
        }
      }
      .acc_cz{
        background url('./images/wlbtn.png') no-repeat 0 -143px;
        &:hover{
          background url('./images/wlbtn.png') no-repeat -140px -143px;
        }
      }
      .top{
        width 37px;
        height 31px;
        display block;
        text-indent -9999px;
        margin 0 auto;
        margin-top 13px;
        background url('./images/top_btn.png') no-repeat 0 0;
        cursor pointer;
      }
    }
</style>
<script>
export default {
  beforeMount() {

  },
  mounted() {

  },
  methods: {
    goTop: function() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
}
</script>
